import React from "react"
import SocialLinks from "./social-links"
import Circle from "./circle"


const email = `contact@zoomhr.ca`;
const tel = `289.208.4107`;

const Footer = ({ siteTitle }) => (
  <footer>
    <div className={`page-wrap`}>
      <div className={`footer-text`}>
        <p className={`blue-text`}>Take your company to the next level with your employees driving the growth.</p>
        <a href={`mailto:${email}`} className={`cta-text`}>Contact us today.</a>
      </div>
      <div className={`footer-social`}>
        <SocialLinks type={`footer`}/>
      </div>
      <div className={'footer-contact'}>
        <div className={`contact-part contact-email`}><a href={`mailto:${email}`}>{email}</a></div>
        <div className={`contact-part contact-phone`}><a href={`tel:${tel}`}>{tel}</a></div>
      </div>
    </div>

    <Circle id="c7" speed={2} opacity={1}/>
    <Circle id="c8" speed={3} modifiers={`quarter--blue`} rotation={`180deg`} opacity={1}/>

  </footer>
)


export default Footer
